<template>
  <div>
    <AppHeader />
    <router-view :key="key" />
  </div>
</template>

<script>
import AppHeader from "./components/AppHeaderHome";
import AppFooter from "./components/AppFooter";
export default {
  name: "index1.vue",
  components: { AppFooter, AppHeader },
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style scoped></style>
